import { getHeaderTitle, Header } from "@react-navigation/elements";
import * as React from "react";
import { useState } from "react";
import { Platform, StyleSheet } from "react-native";
import Animated, {
  Easing,
  useAnimatedStyle,
  useDerivedValue,
  withTiming,
} from "react-native-reanimated";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useScrollContext } from "./ScrollContext";
import { useDispatch } from "react-redux";
import { setNavigationHeight } from "@redux/slices/appStateSlice";
import { useTheme } from "styled-components/native";
import FreeTrialBanner from "@components/atoms/HeaderBanner/FreeTrialBanner";
import { useUserInfo } from "@redux/slices/userInfoSlice";

const VDBHeader = ({ route, options, rightComponent, customStyles }: any) => {
  const dispatch = useDispatch();
  const [scrollValue] = useScrollContext();
  const { top } = useSafeAreaInsets();
  const theme = useTheme();
  const [headerHeight, setHeaderHeight] = useState(0);
  const height = top + headerHeight;
  const title = getHeaderTitle(options, route.name);
  const userInfo = useUserInfo();
  const shownAmount = useDerivedValue(() =>
    withTiming(scrollValue.value > 0.2 ? 1 : 0, {
      duration: 550,
      easing: Easing.out(Easing.cubic),
    })
  );
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateY: shownAmount.value * -height }],
  }));

  const showTrialBanner =
    userInfo.user.id &&
    (userInfo.isActiveFreeTrial() || userInfo.hasNoPlan()) &&
    !userInfo.isUpcomingPaidPlan() &&
    userInfo?.user?.feature_settings?.display_paid_marketplace_plan_popup &&
    Object.keys(userInfo.user.plan_details).length > 0;

  const hideHeaderLine = userInfo.user?.iframe_status === true;
  return (
    <Animated.View
      style={[
        styles.root,
        { backgroundColor: options.headerStyle?.backgroundColor },
        {
          paddingTop: top + (customStyles?.marginTop ?? 0),
          borderLeftWidth: 0,
        },
        theme.isMobile && animatedStyle,
        theme.isLargeScreen
          ? {
              position: "relative",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }
          : {},
      ]}
      onLayout={(event) => {
        const currentHeight = event.nativeEvent.layout.height;
        if (!isNaN(currentHeight) && currentHeight >= 0) {
          setHeaderHeight(currentHeight);
          dispatch(setNavigationHeight(currentHeight));
        }
      }}
    >
      <Header
        {...options}
        title={title}
        headerStatusBarHeight={0}
        headerStyle={{
          ...options.headerStyle,
          ...(hideHeaderLine && {
            borderBottomWidth: 0,
            elevation: 0,
            boxShadow: "none",
          }),
          ...(theme.isMobile
            ? {}
            : Platform.OS === "web"
            ? {
                height: top + 62,
              }
            : {
                height: top + 50,
              }),
        }}
        headerShadowVisible={!hideHeaderLine}
      />
      {rightComponent}
      {showTrialBanner && <FreeTrialBanner />}
    </Animated.View>
  );
};

export default VDBHeader;

// It can't be added as styled component because is Animated dynamically
const styles = StyleSheet.create({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
  },
});
